import React, { Component } from 'react';
import './AnnouncementBar.css';

class AnnouncementBar extends Component {
  constructor() {
    super();
  }
  render() {
    return (
      <div className="UnderConstructionBar stillopen">
        <div className="sub_container">
          <h3 className="fadeInUp">
            Learn how to Operationalize Telehealth Populations with Diet ID!
            <div className="ctas">
              <a
                target="_blank"
                href="https://www.dietid.com/blog"
                className="cta"
              >
                Learn More
              </a>
            </div>
          </h3>
        </div>
      </div>
    );
  }
}

export default AnnouncementBar;
